import styled from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  min-height: 100vh;
  padding-top: 120px;
  .addButton {
    width: 280px;
    @media (min-width: 768px) {
      width: 330px;
    }
  }
  @media (min-width: 768px) {
    padding-top: 150px;
  }
`;

export const HUContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const CardsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;
